// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KM0t","questions":"styles_questions__Td6jU","footer":"styles_footer__FpFlU"};